import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';

const AuthModal = () => {
  const { showAuthModal, authMode, closeAuthModal, switchAuthMode } = useAuth();

  if (!showAuthModal) return null;

  return (
    <>
      {authMode === 'login' ? (
        <LoginForm 
          onClose={closeAuthModal} 
          onSwitchToSignup={switchAuthMode}
        />
      ) : (
        <SignupForm 
          onClose={closeAuthModal} 
          onSwitchToLogin={switchAuthMode}
        />
      )}
    </>
  );
};

export default AuthModal;
